import React from "react";
import { TextField, TextFieldProps } from "mui-rff";

export default function FullWidthInput(props: TextFieldProps) {
    return <TextField fullWidth margin="normal" required {...props} />;
}
